module.exports = __webpack_public_path__ + "img/preloader-bg.8122c8bf.png";